import React, { Component } from 'react'
import StyleSheet from 'styles'
import { connect } from 'react-redux'
import { Loader } from 'components'

export class GlobalLoaderOverlay extends Component{
  render = () =>
    this.props.loading && (
      <div className={styles.loaderWrapper}>
        <div className={styles.loaderContainer}>
          <Loader/>
        </div>
      </div>
    )
}

const styles = StyleSheet({
  loaderWrapper: {
    position: 'relative',
    top: 0,
    '@media(max-width: 600px)': {
      top: 65
    },
    bottom: 0,
    left: 0,
    right: 0,
    height: 0,
    zIndex: 100
  },
  loaderContainer: {
    position: 'absolute',
    zIndex: 100,
    width: '100vw',
    height: 2000,
    left: 0,
    right: 0,
    background: 'rgba(0, 0, 0, 0.5)'
  }
})



export default connect(({globalLoader}) => globalLoader)(GlobalLoaderOverlay)